import styled from '@emotion/styled';
import { EnhancedSelect as _EnhancedSelect } from 'common/components/EnhancedSelect/EnhancedSelect';

export const SContainer = styled.div`
  width: 306px;
  padding: 13px;
`;

export const STitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
`;

export const SControl = styled.div`
  margin-block: 12px;
  .ant-picker {
    width: 100%;
  }

  & .select-accounts-customers .ant-select-selector {
    padding: 0 6px;
  }
  & .select-accounts-customers .ant-select-selection-item {
    padding-right: 12px;
    font-size: 9px !important;
  }
`;

export const SEnhancedSelect = styled(_EnhancedSelect)<{ currencySelect?: boolean }>`
  width: 100%;
  .ant-select-selection-placeholder {
    ${({ currencySelect }): string => currencySelect ? `font-size: 8px;` : ''}
  }
`;

export const SSelectRow = styled.div`
  margin-top: 8px;
  display: flex;
  & ${SEnhancedSelect}:first-of-type {
    & .ant-select-selection-item {
      font-size: 13px;
    }
  }
  & .ant-input {
    width: 100%;
  }
  & .ant-form-item:not(:first-of-type) .ant-input {
    border-left: none;
  }
`;
